"use client";

import Divider from "@/components/ui/Divider";
import { LinkService } from "@/lib/navigation";
import { OptimizedImage } from "@/components/ui/OptimizedImage";
import Link from "next/link";

interface FooterProps {
  hideNav?: boolean;
}

export default function Footer({ hideNav = false }: FooterProps) {
  const currentYear = new Date().getFullYear();
  const navLinks = hideNav ? [] : LinkService.getNavLinks();
  const socialLinks = LinkService.getSocialLinks();

  return (
    <div id="footer" className="container flex flex-col mx-auto my-2 sm:my-4 z-30">
      <Divider bgClassName={"bg-gray-200"} />

      <div className="flex flex-col items-center w-full my-4 sm:my-6">
        {/* Logo */}

                <div
          style={{ position: "relative", height: "50px", width: "100%", maxWidth: "500px" }}
          className="mb-2"
        >
          <OptimizedImage
            src="/images/logo/atc-logo-abbreviated-transparent.png"
            alt="Acquired Taste Comedy Logo"
            fill
            sizes="(max-width: 1024px) 100px, 120px"
            style={{ objectFit: "contain" }}
          />
        </div>

        {/* Navigation and Social Links */}
        <div className="flex flex-col items-center gap-6 mb-4 sm:mb-6">
          <div className="flex flex-col sm:flex-row sm:flex-wrap md:flex-row items-center justify-center gap-5 lg:gap-12 gap-y-3 lg:flex-nowrap text-foreground">
            {navLinks.map((link) => (
              <Link
                key={link.slug}
                href={link.slug}
                className="text-muted-foreground hover:text-foreground"
              >
                <span>{link.title}</span>
              </Link>
            ))}
          </div>

          <div className="flex items-center justify-center space-x-4 gap-2 text-primary">
            {socialLinks.map((link) => (
              <a
                key={link.slug}
                href={link.slug}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full border-0 font-light leading-tight hover:bg-muted"
              >
                <link.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="flex items-center">
          <p className="text-base font-normal leading-7 text-center text-muted-foreground">
            <span>© {currentYear} Acquired Taste Comedy.</span>
            <span className="block sm:inline"> All rights reserved.</span>
          </p>
        </div>
      </div>
    </div>
  );
}

// Optional CSS for active link styling
export const footerStyles = `

`;
